'use strict';

import * as statsList from '../actions/statsList';

let defaultState = {
    referralStats: []
};

export default function(state = defaultState, action) {

    switch (action.type) {

        case statsList.REFERRAL_STATS_REFRESHED:

            return {
                ...state,
                referralStats: action.referralData
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./reducers/statsList.js